module.exports = __webpack_public_path__ + "static/media/ASCBN-TITLE-HORIZONTAL-DARK-TRANSPARENT.d2fbb2cc.png";